// Telegramdan yoki xarita ilovalaridan kelgan havoladan koordinata ajratadi.
//
// Admin odatda tuman markazining koordinatasini bilmaydi — unga kimdir
// Telegramda lokatsiya tashlaydi. Uni ochib "Google Maps'da ochish" bosilsa,
// manzil satrida koordinata turadi. Shu matnni shundayligicha qo'yish
// kifoya qilsin — qo'lda kenglik/uzunlik ko'chirib o'tirmasin.

// O'zbekiston chegaralari — koordinatalar o'rni almashib ketganini sezish uchun.
const UZ = { latMin: 37.1, latMax: 45.6, lngMin: 55.9, lngMax: 73.2 };

const son = '(-?\\d+(?:\\.\\d+)?)';

const tekshir = (lat, lng) => {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  if (lat === 0 && lng === 0) return null;

  return {
    latitude: lat,
    longitude: lng,
    // Nuqta O'zbekistondan tashqarida bo'lsa ogohlantiramiz: ko'pincha
    // kenglik va uzunlik o'rni almashib ketgan bo'ladi (41,69 -> 69,41).
    uzbekistondanTashqarida:
      lat < UZ.latMin || lat > UZ.latMax || lng < UZ.lngMin || lng > UZ.lngMax
  };
};

// Qisqartirilgan havolalar (maps.app.goo.gl, goo.gl/maps) ichida koordinata
// yo'q — u faqat serverga borgach ochiladi. Brauzerdan buni o'qib bo'lmaydi.
const QISQA = /(goo\.gl\/maps|maps\.app\.goo\.gl|yandex\.ru\/maps\/-\/|t\.me\/)/i;

/// Matndan koordinata ajratadi.
///
/// Qaytaradi: { latitude, longitude, uzbekistondanTashqarida } yoki
/// { qisqaHavola: true } yoki null (topilmadi).
export function parseLocation(text) {
  if (!text) return null;
  const s = String(text).trim();
  if (!s) return null;

  // 1. Yandex Xarita: ll=uzunlik,kenglik — TARTIBI TESKARI.
  //    Boshqa qoidalardan oldin tekshiriladi, aks holda joylar almashib ketadi.
  const yandex = s.match(new RegExp(`[?&](?:ll|pt)=${son}(?:%2C|,)${son}`, 'i'));
  if (yandex) return tekshir(Number(yandex[2]), Number(yandex[1]));

  // 2. Google Maps: .../@41.311081,69.240562,17z
  const at = s.match(new RegExp(`@${son},${son}`));
  if (at) return tekshir(Number(at[1]), Number(at[2]));

  // 3. Google Maps ichki ko'rinishi: !3d<kenglik>!4d<uzunlik>
  const bang = s.match(new RegExp(`!3d${son}!4d${son}`));
  if (bang) return tekshir(Number(bang[1]), Number(bang[2]));

  // 4. OpenStreetMap: #map=17/41.31/69.24
  const osm = s.match(new RegExp(`#map=\\d+\\/${son}\\/${son}`));
  if (osm) return tekshir(Number(osm[1]), Number(osm[2]));

  // 5. Telegramning "Google Maps'da ochish" havolasi: ?q=41.31,69.24
  //    va telefonlardagi geo:41.31,69.24
  const q = s.match(new RegExp(`(?:[?&]q=|geo:)${son}(?:%2C|,)\\s*${son}`, 'i'));
  if (q) return tekshir(Number(q[1]), Number(q[2]));

  // 6. Shunchaki nusxalangan juftlik: "41.311081, 69.240562"
  const juft = s.match(new RegExp(`^${son}\\s*[,;\\s]\\s*${son}$`));
  if (juft) return tekshir(Number(juft[1]), Number(juft[2]));

  // Koordinata topilmadi. Sababi qisqa havola bo'lsa — buni aytamiz,
  // chunki foydalanuvchi uni to'g'ri deb o'ylaydi.
  if (QISQA.test(s)) return { qisqaHavola: true };

  return null;
}

// O'zbekiston chegarasi ichidami.
export function uzbekistonIchida(lat, lng) {
  const a = Number(lat), b = Number(lng);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return false;
  return a >= UZ.latMin && a <= UZ.latMax && b >= UZ.lngMin && b <= UZ.lngMax;
}

/// Kenglik va uzunlik o'rni almashib ketganmi.
///
/// Eng ko'p uchraydigan xato: 41.2, 61.3 o'rniga 61.3, 41.2 yoziladi.
/// Nuqta O'zbekistondan tashqarida, lekin almashtirilsa ichida bo'lsa —
/// bu aniq o'rin almashuvi, taxmin emas.
export function almashganKoordinata(lat, lng) {
  return !uzbekistonIchida(lat, lng) && uzbekistonIchida(lng, lat);
}
